<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t('preInvoice.pageTitle'),
              href: '/pre-invoices'
            },
            {
              text: $t('add_new'),
              active: true
            }
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-6">
                <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('preInvoice.studentInfo') }}</legend>
                <div class="row form-group">
                    <label class="col-form-label col-md-4">{{ $t('preInvoice.cardNumber') }}:</label>
                    <div class="col-md-8">
                        <a-select style="width: 100%" disabled 
                        :value="showData.student.card_number"></a-select>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-4">{{ $t('preInvoice.studentName') }}:</label>
                    <div class="col-md-8">
                        <a-select style="width: 100%" disabled 
                        :value="showData.student.full_name_en"></a-select>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-4">{{ $t('preInvoice.sex') }}:</label>
                    <div class="col-md-8">
                        <a-select style="width: 100%" disabled 
                        :value="showData.student.gender"></a-select>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-4">{{ $t('preInvoice.dateOfBirth') }}:</label>
                    <div class="col-md-8">
                        <a-select style="width: 100%" disabled 
                        :value="showData.student.date_of_birth"></a-select>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-4">{{ $t('preInvoice.phone') }}:</label>
                    <div class="col-md-8">
                        <a-select style="width: 100%" disabled 
                        :value="showData.student.phone"></a-select>
                    </div>
                </div>
              </fieldset>
            </form>
            </div>
            <div class="col-md-6">
                <form class="form-horizontal">
                    <fieldset>
                        <legend>{{ $t('preInvoice.academic') }}</legend>
                        <div class="row form-group">
                            <label class="col-form-label col-md-4">{{
                                $t('preInvoice.mainProgram')
                            }}:</label>
                            <div class="col-md-8">
                                <a-select style="width: 100%" disabled 
                                :value="
                                    showData.main_program
                                    ? showData.main_program.acp_name_foreign
                                    : ''
                                "></a-select>
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-form-label col-md-4">{{
                                $t('preInvoice.subProgram')
                            }}:</label>
                            <div class="col-md-8">
                                <a-select style="width: 100%" disabled 
                                :value="
                                    showData.sub_program
                                    ? showData.sub_program.acps_name_foreign
                                    : ''
                                "></a-select>
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-form-label col-md-4">{{
                                $t('preInvoice.academicTermName')
                            }}:</label>
                            <div class="col-md-8">
                                <a-select style="width: 100%" disabled 
                                :value="
                                    showData.academic_term
                                    ? showData.academic_term.term_name
                                    : ''
                                "></a-select>
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-form-label col-md-4">{{
                                $t('preInvoice.gradeName')
                            }}:</label>
                            <div class="col-md-8">
                                <a-select style="width: 100%" disabled 
                                :value="
                                    showData.grade
                                    ? showData.grade.grade_name_foreign
                                    : ''
                                "></a-select>
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-form-label col-md-4">{{
                                $t('preInvoice.remark')
                            }}:</label>
                            <div class="col-md-8">
                                <textarea class="form-control" rows="3" v-model="model.remark"></textarea>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <panel :title="$t('preInvoice.item')">
                <div>
                  <ts-loading-banner :loading="loading">
                    <div class="overflow-auto">
                      <div id="list-container">
                        <table class="ts-table" style="min-width:1520px">
                          <thead>
                            <tr>
                              <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.feeType') }}</th>
                              <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.feeName') }}</th>
                              <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.description') }}</th>
                              <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.dateFrom') }}</th>
                              <th style="width:250px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.dateTo') }}</th>
                              <th style="width:110px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.qty') }}</th>
                              <th style="width:110px;" class="ts-uppercase ts-border-b">{{ $t('preInvoice.fee') }}</th>
                              <th style="width:120px" class="text-center ts-uppercase ts-border-b">
                                {{ $t('preInvoice.discountType') }}
                              </th>
                              <th style="width:120px" class="text-center ts-uppercase ts-border-b">
                                {{ $t('preInvoice.discount') }}
                              </th>
                              <th style="width:110px" class="text-center ts-uppercase ts-border-b">
                                {{ $t('preInvoice.vat') }}
                              </th>
                              <th style="width:110px" class="ts-uppercase ts-border-b">{{ $t('preInvoice.amount') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in model.inv_detail_list" :key="index">
                              <td>
                                <a-select
                                  v-model="item.fee_type_id"
                                  showSearch
                                  style="width: 100%"
                                  :options="
                                    getFeeType(item.fee_type_id).map(el => ({
                                      value: el.fee_type_id,
                                      label: el.fee_type_name
                                    }))
                                  "
                                  optionFilterProp="children"
                                  :filterOption="
                                    (input, option) =>
                                      option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                  "
                                  @change="onFeeTypeChange(item)"
                                />
                                <div
                                  class="validate"
                                  v-if="
                                    errors.has('inv_detail_list.' + index + '.fee_type_id')
                                  "
                                >
                                  {{
                                    errors.first('inv_detail_list.' + index + '.fee_type_id')
                                  }}
                                </div>
                              </td>
                              <td>
                                <a-select
                                  v-model="item.fee_setup_id"
                                  showSearch
                                  style="width: 100%"
                                  :maxTagTextLength="30"
                                  :options="getFeeSetupByFeeType(item.fee_type_id)"
                                  optionFilterProp="children"
                                  :filterOption="
                                    (input, option) =>
                                      option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                  "
                                  @change="onFeeSetupChange(item)"
                                />
                                <div
                                  class="validate"
                                  v-if="
                                    errors.has('inv_detail_list.' + index + '.fee_setup_id')
                                  "
                                >
                                  {{
                                    errors.first('inv_detail_list.' + index + '.fee_setup_id')
                                  }}
                                </div>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="item.fee_description"
                                />
                              </td>
                              <td class="ts-whitespace-no-wrap">
                                <a-date-picker
                                  mode="date"
                                  v-model="item.fee_start_date"
                                  format="DD-MM-YYYY"
                                  @change="startDateChange(item)"
                                />
                              </td>
                              <td>
                                <a-date-picker
                                  mode="date"
                                  v-model="item.fee_end_date"
                                  format="DD-MM-YYYY"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="item.quantity"
                                  @input="calculate()"
                                />
                                <div
                                  class="validate"
                                  v-if="errors.has('inv_detail_list.' + index + '.quantity')"
                                >
                                  {{ errors.first('inv_detail_list.' + index + '.quantity') }}
                                </div>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  readonly
                                  class="form-control"
                                  v-model="item.fee_amount"
                                />
                              </td>
                              <td>
                                <a-select
                                  v-model="item.discount_type"
                                  style="width: 100%"
                                  :options="[
                                    { value: '$', label: '$' },
                                    { value: '%', label: '%' }
                                  ]"
                                  @change="calculate"
                                />
                                <div
                                  class="validate"
                                  v-if="
                                    errors.has('inv_detail_list.' + index + '.discount_type')
                                  "
                                >
                                  {{
                                    errors.first(
                                      'inv_detail_list.' + index + '.discount_type'
                                    )
                                  }}
                                </div>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="item.discount_rate"
                                  @input="calculate()"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="item.vat_rate"
                                  @input="calculate()"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  class="form-control"
                                  readonly
                                  v-model="item.total_amount"
                                />
                                <div
                                  class="validate"
                                  v-if="
                                    errors.has('inv_detail_list.' + index + '.total_amount')
                                  "
                                >
                                  {{
                                    errors.first('inv_detail_list.' + index + '.total_amount')
                                  }}
                                </div>
                              </td>
                              <td class="text-center">
                                <a href="#" @click.prevent="removeRow(item)">
                                  <i class="py-2 fa fa-trash text-red"></i>
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td class="ts-text-left ts-p-1 ts-w-12">
                              <button 
                                class="ts-bg-blue-500 ts-text-white ts-rounded-full ts-p-1 ts-flex hover:ts-bg-blue-600
                                ts-items-center ts-justify-center ts-shadow-sm hover:ts-shadow-md ts-outline-none focus:ts-outline-none"
                                @click.prevent="addNewRow"
                                aria-label="Add new row"
                              >
                                <i class="fa fa-plus ts-text-xs"></i>
                              </button>
                            </td>
                            </tr>
                            <tr>
                              <td colspan="10" class="text-right">
                                <strong>{{ $t('preInvoice.total') }}:</strong>
                              </td>
                              <td class="text-right">
                                <u>
                                  <strong>{{ model.total_amount }}</strong>
                                </u>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </ts-loading-banner>
                </div>
              </panel>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button @click.prevent="$router.push({ name: 'pre-invoice' })">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                class="ml-2"
                :waiting="update_waiting"
                @click.prevent="onUpdate"
                color="primary"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </div>
  </template>
  
  <script>
  import ItemList from './component/item-list'
  import moment from 'moment'
  import { round, ceil, sumBy } from 'lodash'
  import { Errors } from 'form-backend-validation'
  import { mapState, mapActions } from 'vuex'
  
  export default {
    name: 'preInvoiceEdit',
    components: {
      ItemList,
    },
    data() {
      return {
        model: {
          pre_inv_date: moment().format('DD-MM-YYYY'),
          student_id: '',
          ac_year_id: '',
          acp_id: '',
          ac_status_id: '',
          term_stop: '',
          acps_id: '',
          ac_term_id: null,
          grade_id: null,
          study_time: '',
          total_amount: '',
          remark: '',
          vehicle_id: '',
          preview: true,
          inv_detail_list: []
        },
        newRow: {
          fee_type_id: null,
          fee_setup_id: null,
          fee_description: null,
          quantity: 1,
          fee_start_date: null,
          fee_end_date: null,
          payment_term_id: null,
          duration_in_month: 0,
          fee_amount: 0,
          discount_type: '%',
          discount_rate: 0,
          discount_amount: 0,
          discount_reason: null,
          total_amount: 0,
          vat_rate: 0,
          vat_amount: 0,
          amount_include_vat: 0,
          ac_term_id: null,
          grade_id: null,
          shift_id: null
        },
        feeTypes: [],
        feeSetupsWithDetail: {},
        errors: new Errors(),
        loading: false,
        update_waiting: false,
        save_add_new_waiting: false,
        studentInfo: null
      }
    },
    computed: {
        ...mapState('preInvoice', ['showData'])
    },
    created() {
        this.setEditData()
        this.fetchFeeType()
    },
    methods: {
      ...mapActions('preInvoice', ['preInvoiceFormView']),
      addNewRow() {
        this.model.inv_detail_list.push(_.clone(this.newRow))
      },
      removeRow(row) {
        this.model.inv_detail_list.splice(
          this.model.inv_detail_list.indexOf(row),
          1
        )
        this.model.total_amount = _.sumBy(
          this.model.inv_detail_list,
          'total_amount'
        )
        this.calculate()
      },
      onUpdate() {
        this.errors = new Errors()
        this.update_waiting = true
        this.$store
          .dispatch('preInvoice/update', {
            id: this.model.inv_id,
            data: this.model
          })
          .then(response => {
            this.$toasted.success(response.message)
            this.pushBack()
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.update_waiting = false
          })
      },
      getFeeSetupByFeeType(feeTypeId) {
        let result = this.feeSetupsWithDetail[feeTypeId]
        
        if (result != undefined) {
          return result.map(el => ({
            value: el.fee_setup_id,
            id: el.fee_setup_id,
            label: el.fee_name
          }))
        }

        let preInvoiceDetail = this.showData.pre_invoice_detail
       
        if (preInvoiceDetail) {
          return preInvoiceDetail.map(el => ({
            value: el.fee_setup_id,
            id: el.fee_setup_id,
            label: el.fee_description
          }))
        }
        
        return []
      },
      getFeeType(currentFeeTypeId) {

        if (!this.model.inv_detail_list || this.model.inv_detail_list.length === 0) {
            return this.feeTypes;
          }

          // Get all fee type IDs except the current one
          const feeTypeIds = this.model.inv_detail_list
            .filter(el => el.fee_type_id !== currentFeeTypeId)
            .map(el => el.fee_type_id);
          
          // Filter out all used fee types except the current one
          return this.feeTypes.filter(feeType => 
            !feeTypeIds.includes(feeType.fee_type_id) || feeType.fee_type_id === currentFeeTypeId
          );
      },
      startDateChange(item) {
        if ([0, 3, 6, 12].includes(item.duration_in_month)) return;

        item.fee_end_date = moment(
          item.fee_start_date.format('DD-MM-YYYY'),
          'DD-MM-YYYY'
        ).add(item.duration_in_month, 'M')
          .subtract(1, 'day'); 
      },
      calculate() {
        let price = 0;
        if (this.model.inv_detail_list.length > 0) {
          this.model.inv_detail_list.forEach(item => {
            price = item.fee_amount ? item.fee_amount * item.quantity : 0
            if (item.discount_type == '%') {
              item.discount_amount = item.discount_rate
                ? price * round(item.discount_rate / 100, 4)
                : 0
            }
            if (item.discount_type == '$') {
              item.discount_amount = item.discount_rate
            }
            item.vat_amount =
              ((price - item.discount_amount) * item.vat_rate) / 100
            item.total_amount =
              ceil(price - item.discount_amount, 2) + item.vat_amount
            item.amount_include_vat = ceil(
              price - item.discount_amount + item.vat_amount,
              2
            )
            this.model.total_amount = sumBy(
              this.model.inv_detail_list,
              'total_amount'
            )
          })
        } else {
          this.model.total_amount = 0
        }
      },
      fetchFeeType(){
        this.loading = true
        this.preInvoiceFormView({
              fnName: 'feeTypeEdit',
            })
            .then((response) => {
                this.feeTypes = response.feeTypeEdit
              })
            .finally(() => {
              this.loading = false
            })
      },
      onFeeSetupChange(item) {
        if(this.feeSetupsWithDetail[item.fee_type_id] == undefined) return []
        this.feeSetupsWithDetail[item.fee_type_id]
          .filter(f => f.fee_setup_id == item.fee_setup_id)
          .forEach(el => {
            item.fee_description = el.fee_name // description is a fee name
            item.quantity = 1
            item.fee_start_date = el.fee_start_date
              ? moment(el.fee_start_date, 'DD-MM-YYYY')
              : null
            item.fee_end_date = el.fee_end_date
              ? moment(el.fee_end_date, 'DD-MM-YYYY')
              : null
            item.payment_term_id = el.payment_term_id
            item.duration_in_month = el.duration_in_month
            item.fee_amount = el.fee_amount
            item.discount_type = '%'
            ;(item.discount_rate = el.discount_rate),
              (item.discount_reason = el.discount_remark)
            item.ac_term_id = el.ac_term_id
            item.grade_id = el.grade_id
            item.shift_id = el.shift_id
          })
        this.calculate()
      },
      async onFeeTypeChange(feeType) {  
          let response = await this.preInvoiceFormView({
              grade_id: this.model.grade_id,
              ac_term_id: this.model.ac_term_id,
              student_id: this.model.student_id,
              end_date_of_term: this.model.term_stop,
              fee_type_id: feeType.fee_type_id,
              invoice_date: this.model.pre_inv_date,
              inv_date: moment().format('DD-MM-YYYY'),
              room_type_id: 1,
              invoice_id: this.model.invoice_id,
              fnName: 'getFeeSetupWithDetailEdit',
            })

          this.clearAfterFeeTypeSetupChange(feeType)

          this.feeSetupsWithDetail = Object.assign(
            {},
            this.feeSetupsWithDetail,
            response.getFeeSetupWithDetailEdit
          ) 
      },
      clearAfterFeeTypeSetupChange(feeType) {
        ;(feeType.fee_description = ''),
          (feeType.quantity = 1),
          (feeType.fee_setup_id = null),
          (feeType.fee_start_date = null),
          (feeType.fee_end_date = null),
          (feeType.payment_term_id = null),
          (feeType.duration_in_month = null),
          (feeType.fee_amount = 0),
          (feeType.discount_type = '%'),
          (feeType.discount_rate = 0),
          (feeType.discount_amount = 0),
          (feeType.discount_reason = null),
          (feeType.total_amount = 0),
          (feeType.vat_rate = 0),
          (feeType.vat_amount = 0),
          (feeType.amount_include_vat = 0),
          (feeType.ac_term_id = null),
          (feeType.grade_id = null),
          (feeType.shift_id = null)
      },
      pushBack() {
        this.$router.push({ name: 'pre-invoice' })
      },
      setEditData() {
            this.model.inv_id = this.showData.inv_id,
            this.model.ac_year_id = this.showData.ac_year_id,
            this.model.acp_id = this.showData.acp_id,
            this.model.acps_id = this.showData.acps_id,
            this.model.remark = this.showData.remark,
            this.model.study_time = this.showData.study_time,
            this.model.student_id = this.showData.student_id,
            this.model.ac_term_id = this.showData.ac_term_id,
            this.model.grade_id = this.showData.grade_id,
            this.model.total_amount = this.showData.total_amount,
            this.showData.pre_invoice_detail.forEach(item => {
                this.model.inv_detail_list.push({
                    ac_term_id: item.ac_term_id,
                    grade_id: item.grade_id,
                    shift_id: item.shift_id,
                    payment_term_id: item.payment_term_id,
                    fee_type_id: item.fee_type_id,
                    fee_setup_id: item.fee_setup_id,
                    fee_description: item.fee_description,
                    quantity: item.quantity,
                    fee_start_date: item.fee_start_date,
                    fee_end_date: item.fee_end_date,
                    discount_rate: item.discount_rate,
                    vat_rate: item.vat_rate,
                    vat_amount: item.vat_amount,
                    duration_in_month: item.duration_in_month,
                    amount_include_vat: item.amount_include_vat,
                    discount_amount: item.discount_amount,
                    discount_reason: item.discount_reason,
                    amount_include_vat: item.amount_include_vat,
                    total_amount: item.total_amount,
                    fee_start_date: item.fee_start_date
                                  ? moment(item.fee_start_date, 'DD-MM-YYYY')
                                  : null,
                    fee_end_date: item.fee_end_date
                                  ? moment(item.fee_end_date, 'DD-MM-YYYY')
                                  : null,
                    discount_type: '%',
                    fee_amount: item.fee_amount
                });
            });
      }
    },
    watch: {
     'model.inv_detail_list': {
        handler(newList) {
          newList.forEach(el => {
            if (el.fee_type_id) {
              this.onFeeTypeChange({ fee_type_id: el.fee_type_id });
            }
          });
        },
        deep: true // Enables deep watching of array elements
      }
    }
  }
  </script>
  